module.exports = __webpack_public_path__ + "img/1480956349.999ba29a.jpg";